export default "__VITE_ASSET__dd513c3a__"